import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledWrapper = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: #111111;
	transition: opacity 0.3s ease;

	&.app-enter {
		opacity: 0;
	}

	&.app-enter-active,
	&.app-enter-done,
	&.app-exit {
		opacity: 1;
	}

	&.app-exit-active {
		opacity: 0;
	}
`;

const StyledContainer = styled.div`
	position: relative;
	z-index: 2;
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 630px;
	margin-top: 50px;
	border-top: 1px solid rgba(255, 255, 255, 0.1);

	& > ${Text} {
		z-index: 20;
	}
`;

const StyledTimer = styled.div`
	position: relative;
	z-index: 20;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 20px;
	margin-top: 15px;
	padding: 0 5px;
	background-color: #ffffff;
	border-radius: 6px;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #000000;
	}
`;

export { StyledContainer, StyledTimer, StyledWrapper };
